import React from "react";
import successIconForModal from "@src/assets/svg/success-icon-for-modal.svg";
import greenColorIndicatorIcon from "@src/assets/svg/green-color-indicator-icon.svg";
import completedCheckboxIcon from "@src/assets/svg/completed-checkbox-icon.svg";
import { Button } from "@src/components/atoms/buttons/button/button";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import styles from "./ota-installation-complete-modal.module.scss";
import { useOtaInstallationCompleteModal } from "./use-ota-installation-complete-modal";

const cssClassName = "ota-installation-complete-modal";

interface OTAInstallationCompleteModalProps {
  activeInstallationData: ActiveInstallationProcessPayload;
  onClose: () => void;
}

const OTAInstallationCompleteModal = ({
  activeInstallationData,
  onClose,
}: OTAInstallationCompleteModalProps) => {
  const { texts, folders, handleCloseModal } = useOtaInstallationCompleteModal(
    activeInstallationData,
  );

  const closeModal = () => {
    handleCloseModal();
    onClose();
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__overlay`]} />
      <div className={styles[`${cssClassName}__dialog-wrapper`]}>
        <div
          className={styles[`${cssClassName}__modal-body`]}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles[`${cssClassName}__header`]}>
            <h2 className={styles[`${cssClassName}__title`]}>{texts.title}</h2>
          </div>

          <div className={styles[`${cssClassName}__content`]}>
            <img
              src={successIconForModal}
              alt=""
              className={styles[`${cssClassName}__success-icon`]}
            />

            <h3 className={styles[`${cssClassName}__subtitle`]}>
              {texts.subtitle}
            </h3>

            <p className={styles[`${cssClassName}__description`]}>
              {texts.descriptionHasItemName ? (
                <>
                  {texts.descriptionPrefix}
                  <span
                    className={styles[`${cssClassName}__firmware-name`]}
                    title={texts.firmwareName}
                  >
                    {texts.firmwareName}
                  </span>
                  {texts.descriptionSuffix}
                </>
              ) : (
                texts.description
              )}
            </p>

            {folders.length > 0 && (
              <div className={styles[`${cssClassName}__folders-card`]}>
                {folders.map((folder) => (
                  <div
                    key={folder}
                    className={styles[`${cssClassName}__folder-row`]}
                  >
                    <div
                      className={styles[`${cssClassName}__folder-name-wrapper`]}
                    >
                      <img src={greenColorIndicatorIcon} alt="" />
                      <span className={styles[`${cssClassName}__folder-name`]}>
                        \{folder}
                      </span>
                    </div>

                    <div
                      className={
                        styles[`${cssClassName}__folder-status-wrapper`]
                      }
                    >
                      <img src={completedCheckboxIcon} alt="" />
                      <span
                        className={
                          styles[`${cssClassName}__folder-status-text`]
                        }
                      >
                        {texts.completedStatus}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className={styles[`${cssClassName}__progress-wrapper`]}>
              <div className={styles[`${cssClassName}__progress-track`]}>
                <div className={styles[`${cssClassName}__progress-fill`]} />
              </div>

              <div className={styles[`${cssClassName}__progress-text-row`]}>
                <p className={styles[`${cssClassName}__progress-label`]}>
                  {texts.overallProgressLabel}
                </p>
                <p className={styles[`${cssClassName}__progress-percent`]}>
                  100%
                </p>
              </div>
            </div>
          </div>

          <div className={styles[`${cssClassName}__buttons-wrapper`]}>
            <Button fun={closeModal} text={texts.doneButtonText} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTAInstallationCompleteModal;
